<template lang="pug">
  app-modal(
    :modalNova="true",
    :closeOutside="false",
    :titulo="isEdicao ? demanda.nome : 'Cadastrar demanda'",
    :width="800",
    @closeModal="closeModal"
    )
    template(slot="body")
      validation-observer(ref="observer")
        el-row(:gutter="20").container
          el-col(:span="12")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(label="Nome da demanda:",:required="true")
              el-input.input(
                v-model="demanda.nome"
                :class="{'erro' : errors.length}"
                :maxlength="50"
                type="text"
              )
              br
              span.help.erro {{ errors[0] }}
          el-col(:span="12")
            app-label(label="Responsável pela demanda:", :required="false")
            el-select.input(
              filterable
              multiple
              collapse-tags
              :filter-method="filtrarResponsaveis"
              class="select"
              v-model="demanda.responsaveis"
              placeholder="Selecione"
              value-key="id"
            )
              el-option(
                v-for="item in responsaveisFiltrados",
                :key="item.id",
                :label="item.pessoa.nomeRazaoSocial",
                :value="item"
              )
        el-row(:gutter="20").container
          el-col(:span="12")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(label="Data de início:", :required="true")
              el-date-picker.input(
                type="date",
                placeholder="Selecione",
                format="dd/MM/yyyy",
                v-model="demanda.dataInicio",
                :class="{'erro' : errors.length}"
              )
              br
              span.help.erro {{ errors[0] }}
          el-col(:span="12")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(label="Data de entrega:", :required="true")
              el-date-picker.input(
                type="date",
                placeholder="Selecione",
                format="dd/MM/yyyy",
                v-model="demanda.dataEntrega",
                :class="{'erro' : errors.length}"
              )
              br
              span.help.erro {{ errors[0] }}
        el-row(:gutter="20").container
          el-col(:span="12")
            app-label(label="Estado da demanda:", :required="false")
            el-select.input(
              class="select",
              v-model="demanda.estadoDemanda",
              placeholder="Selecione",
              value-key="id",
            )
              el-option(
                v-for="item in estados",
                :key="item.id",
                :label="item.nome",
                :value="item"
              )
          el-col(:span="12")
            app-label(label="Prioridade da demanda:", :required="false")
            .color-group
              el-select.input(
                class="select",
                v-model="demanda.prioridade",
                placeholder="Selecione",
                value-key="id",
              )
                el-option(
                  v-for="item in prioridades",
                  :key="item.id",
                  :label="item.nome",
                  :value="item",
                )
              .color(:style="corSelecionada")
        el-row(:gutter="20").container
          el-col(:span="24")
            app-label(label="Descrição:", :required="false")
            el-input.input(
              resize="none"
              v-model="demanda.descricao"
              type='textarea',
              rows="4",
            )
        el-row(:gutter="20").container.last
          el-col(:span="24")
            app-label.labelUpload(label="Upload de Arquivos:", :required="false")
            validation-provider(:rules="isValidate", v-slot="{ errors }")
              app-anexo.upload(
                :id="'upload-arquivo'"
                :showAnexar="true"
                @removeFile="removeFile",
                @uploadFile="uploadFile",
                @downloadDocumentoCadastro="download"
                :files="demanda.arquivos",
                :errors="errors",
                v-model="demanda.arquivos")
        el-row(:gutter="20").container.last
          el-col(:span="12")
            app-label(label="Atividades:", :required="false")
            el-button(@click="adicionarAtividade")
              i.fa.fa-plus
              span &nbsp; Cadastrar atividades
        div.atividade(v-for="atividade in demanda.atividades")
          div.atividade-square
            el-checkbox.atividades-square(
              v-model="atividade.concluido"
            )
          div.atividade-content
            el-input.input(
              placeholder="Nome da atividade"
              ref="inputAtividade"
              v-model="atividade.nome"
              @keyup.native.enter="adicionarAtividade"
            )
          el-button(@click="excluirAtividade(atividade)").excluir.atividade-square
            i.fas.fa-trash
    template(slot="footer")
      div.container-footer
        app-buttons-cadastro(
        :isPrimeiroPasso="true",
        :isUltimoPasso="true",
        :showButtonCancelar="isEdicao",
        :showButtonSalvar="false",
        :showButtonDownload="false",
        :finalizarLabel="isEdicao ? 'Salvar' : 'Cadastrar'"
        cancelarLabel="Excluir"
        @finalizar="confirmar"
        @cancelar="excluir"
      )
</template>

<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import Utils from '@/utils/utils'
import AppAnexo from '@/components/AppAnexo'
import FileSaver from 'file-saver'
import axios from '@/utils/api'

export default {
  data () {
    return {
      responsaveisFiltrados: [],
      responsaveis: [],

      estados: [],
      prioridades: [],

      demanda: {
        nome: '',
        responsaveis: [],
        dataInicio: null,
        dataEntrega: null,
        estadoDemanda: null,
        prioridade: null,
        descricao: '',
        atividades: [],
        arquivos: []
      }
    }
  },

  props: {
    idDemanda: {
      required: false
    }
  },

  computed: {
    isEdicao: function () {
      return !!this.idDemanda
    },

    corSelecionada: function () {
      return this.demanda.prioridade ? `background-color: ${this.demanda.prioridade.codigo}` : ''
    }
  },

  mixins: [
    AppNotificacao
  ],

  methods: {
    ...mapActions({
      findAllPrioridades: 'prioridades/findAll',
      findAllEstados: 'estados/findAll',
      getByIdTime: 'paineis/getTimeById',
      saveDemanda: 'demandas/save',
      findById: 'demandas/findById',
      deleteDemanda: 'demandas/delete'
    }),

    adicionarAtividade () {
      this.demanda.atividades = [...this.demanda.atividades, {
        nome: '',
        concluido: false
      }]

      // setTimeout necessário para que o elemento seja criado antes de receber o foco
      setTimeout(() => {
        this.$refs.inputAtividade[this.demanda.atividades.length - 1].focus()
      }, 0)
    },

    excluirAtividade (atividade) {
      this.demanda.atividades = this.demanda.atividades.filter(item => item !== atividade)
    },

    closeModal () {
      this.$emit('closeModal')
    },

    callbackSucesso () {
      this.$emit('callbackSucesso')
    },

    filtrarResponsaveis (filterValue) {
      this.responsaveisFiltrados = this.responsaveis.filter(item => {
        return Utils.normalize(item.pessoa.nomeRazaoSocial).indexOf(Utils.normalize(filterValue)) > -1
      })
    },

    async excluir () {
      this.confirmBox('Você realmente deseja excluir a demanda? Após a exclusão, essa ação não pode ser desfeita.', this.$messages.TITULO_WARNING,
        async () => {
          await this.deleteDemanda(this.demanda.id).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.DEMANDA_EXCLUIDA_SUCESSO
            )
          })
          this.closeModal()
        },
        () => { }, 'Confirmar', 'Cancelar')
    },

    removerAtividadesEmBranco (atividades) {
      return atividades.filter((atividade) => atividade.nome)
    },

    removeFile (file) {
      this.demanda.arquivos.splice(this.demanda.arquivos.findIndex(f => f === file), 1)
    },

    async uploadFile (file) {
      this.demanda.arquivos.push({
        key: file.response,
        nome: file.name,
        base64: file.pathName
      })
    },

    async download (file) {
      const response = await axios({
        method: 'POST',
        url: `anexoMensagem/download?isFormatKey=false`,
        data: file,
        responseType: 'blob'
      })
      FileSaver.saveAs(response, file.nome)
    },

    async confirmar () {
      const valido = await this.$refs.observer.validate()
      this.demanda.atividades = this.removerAtividadesEmBranco(this.demanda.atividades)
      if (valido) {
        try {
          const response = await this.saveDemanda({ demanda: this.demanda, idPainel: this.$route.query.idPainel })
          if (response) {
            if (this.idDemanda) {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.DEMANDA_ATUALIZADA_SUCESSO
              )
            } else {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.DEMANDA_CADASTRO_SUCESSO
              )
            }
            this.closeModal()
          }
        } catch (error) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
        }
      }
    }
  },

  created () {
    this.findAllPrioridades().then(response => {
      this.prioridades = response
    })

    this.findAllEstados().then(response => {
      this.estados = response
    })

    this.getByIdTime(this.$route.query.idPainel).then(response => {
      this.responsaveis = response
      this.responsaveisFiltrados = this.responsaveis
    })

    if (this.idDemanda) {
      this.findById(this.idDemanda).then(response => {
        this.demanda = response
      })
    }
  },

  components: {
    AppModal,
    AppLabel,
    AppButtonsCadastro,
    AppAnexo
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";
@import "@/assets/styles/_variables.scss";

.container {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
}
.last {
  padding-bottom: 10px;
  padding-top: 10px;
}

.atividade {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.atividade-square {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.atividade-content {
  flex: 1;
  margin-left: 10px;
  margin-right: 10px;
}

.input {
  width: 100%;
}

.color-group {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.color {
  margin-left: 10px;
  width: 38px;
  height: 38px;
  border: 1px $border-color solid;
  border-radius: 4px;
}

.excluir:hover,
.excluir:focus {
  background-color: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.el-select >>> .el-tag {
  height: 100%;
}

.el-select-dropdown__item {
  padding-right: 40px;
}

.container-footer {
  padding-left: 10px;
  margin-top: -20px;
}

.labelUpload{
  margin-bottom: -30px;
}

@media (max-width: 1720px) {
  .container-footer {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/ModalCadastrarDemanda.vue